module.exports = __webpack_public_path__ + "static/media/Life-purplish-blue.195b09d8.svg";